
import * as _ from "lodash";
import { OnInit, Component, Input } from "@angular/core";
import * as moment from 'moment';
import { CommonService } from "../services/common.service";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ApiService } from "../services/api.service";

@Component({
    selector: 'process-summary',
    templateUrl: './process-summary.component.html'
})
export class ProcessSummaryComponent implements OnInit {
    @Input("wizard") wizard: any;
    @Input("code") code: any;
    @Input("process") process: any;
    @Input("product") product: any;
    @Input("openRequestCount") openRequestCount: number;
    moment: any = moment;
    groupSummary: any = {};
    groupChangeSubscription: Subscription;

    constructor(public commonService: CommonService,
        private translate: TranslateService,
        private apiService: ApiService
    ) {
        this.groupChangeSubscription = this.commonService.getGroupChangeEvent().subscribe(result => {
            this.initMultilineSummary();

            //multiline group changed so refresh process summary
            this.apiService.post("Api/PolicyAPI/RefreshSummary/", this.wizard).subscribe((result: any) => {
                this.wizard.Summaries = result;
            });
        });
    }

    ngOnChange(){
       
    }

    ngOnInit() {
        this.initMultilineSummary();
    }

    copyText(text : any){
        if(!!text){
            this.commonService.copyToClipBoard(text.toString());
        }
      
    }

    initMultilineSummary() {
        for (var stepCode in this.wizard.Steps) {
            for (var groupCode in this.wizard.Steps[stepCode].ControlGroups) {
                if (this.wizard.Steps[stepCode].ControlGroups[groupCode].IsMultiline) {
                    for (var controlCode in this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls) {
                        if (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Properties['QuoteSummary'].Value) {
                            this.groupSummary[stepCode + groupCode + controlCode] = this.getMultilineSummary(stepCode, groupCode, controlCode);
                        }
                    }
                }
            }
        }      
    }

    getMultilineSummary(stepCode, groupCode, controlCode) : string {
        var summary: string = "";
        for (var lineCode in this.wizard.Steps[stepCode].ControlGroups[groupCode].Lines) {
            if (this.wizard.Steps[stepCode].ControlGroups[groupCode].Lines[lineCode].Controls[controlCode].Value) {
                if ((this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType != 'Lookup')
                    && (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType != 'YesNo')
                    && (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType != 'DateTime'))
                    summary = summary + this.wizard.Steps[stepCode].ControlGroups[groupCode].Lines[lineCode].Controls[controlCode].Value + ";"
                else if (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType == 'DateTime')
                    summary = summary + moment(this.wizard.Steps[stepCode].ControlGroups[groupCode].Lines[lineCode].Controls[controlCode].Value, "DD/MM/YYYY").format("D MMM YYYY");
                else if (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType == 'Lookup')
                    summary = summary + this.wizard.Referentials[this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Referential].Values[this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Value];
                else if ((this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType == 'YesNo')
                    && (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Value == 'Y'))
                    summary = summary + this.translate.instant("Yes");
                else if ((this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].FieldType == 'YesNo')
                    && (this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Value == 'N'))
                    summary = summary + this.translate.instant("No");
            }
            else {
                summary = summary +  "-;"
            }
        }
        return summary;
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.groupChangeSubscription.unsubscribe();
    }
}
